<template>
    <div>
        <div class="mb-2" style="margin-top: -15px;">
            <a @click="$router.go(-1)">
                <font-awesome-icon icon="arrow-circle-left" class="mm-link" style="font-size: 1.5rem;"/>
            </a>
            <router-link to="/" class="ml-2">
                <font-awesome-icon icon="home" class="mm-link" style="font-size: 1.5rem;"/>
            </router-link>
        </div>
        <div class="row mb-3">
            <div v-if="object_list && object_list.length > 0" class="col-12 col-md-3">
                <multi-select
                    v-model="selected_objects"
                    :list="object_list"
                    placeholder="Inserat"
                    :shownAttribute="['id', 'name']"
                    :grey_background="grey_objects"
                />
                <font-awesome-icon icon="filter" class="abs"></font-awesome-icon>
            </div>
            <div class="col-12 col-md-3" v-if="category_list && category_list.length > 0">
                <multi-select
                    v-model="selected_categories"
                    :list="category_list"
                    placeholder="Kategorie"
                    :grey_background="grey_zo_cat"
                />
                <font-awesome-icon icon="filter" class="abs"></font-awesome-icon>
            </div>
            <div class="col-12 col-md-3" v-if="improvement_list && improvement_list.length > 0">
                <multi-select
                    v-model="selected_improvements"
                    :list="improvement_list"
                    :shownAttribute="['title']"
                    placeholder="Zusatzleistungen"
                    :grey_background="grey_zo_cat"
                />
                <font-awesome-icon icon="filter" class="abs"></font-awesome-icon>
            </div>
            <div class="col-12 col-md-3" v-if="improvement_list && improvement_list.length > 0">
                <button class="btn btn-success btn-block" @click="$refs.period_modal.show()">Zeitraum wählen</button>
            </div>
            <div class="col-12 mt-2">
                <div class="row">
                    <div class="col-10">
                        <button class="btn btn-success mr-2" @click="clearFilters" v-if="has_filter">
                            {{$t('intern_object_input.btn_stat_clear_filters')}}
                        </button>
                        <div
                            class="d-inline-block mr-2 font-12 pointer"
                            v-for="object in selected_objects"
                            :key="object.id"
                            @click="removeItemFromFilter(object.id, 'selected_objects')"
                        >
                            <font-awesome-icon icon="times" style="font-size:14px; color: red;"/>
                            Inseratsnummer - {{object.id}}
                        </div>
                        <div
                            class="d-inline-block mr-2 font-12 pointer"
                            v-for="category in selected_categories"
                            :key="category.id"
                            @click="removeItemFromFilter(category.id, 'selected_categories')"
                        >
                            <font-awesome-icon icon="times" style="font-size:14px; color: red;"/>
                            Kategorie - {{category.name}}
                        </div>
                        <div
                            class="d-inline-block mr-2 font-12 pointer"
                            v-for="improvement in selected_improvements"
                            :key="improvement.id"
                            @click="removeItemFromFilter(improvement.id, 'selected_improvements')"
                        >
                            <font-awesome-icon icon="times" style="font-size:14px; color: red;"/>
                            Zusatzoption - {{improvement.title}}
                        </div>
                        <div
                            class="d-inline-block mr-2 font-12 pointer"
                            v-if="dates.period_type && dates.period_type != 'date_picker'"
                            @click="emptyDateFilter()"
                        >
                            <font-awesome-icon icon="times" style="font-size:14px; color: red;"/>

                            {{$t('intern_statistics.' + dates.period_type)}}
                            <template v-if="dates.period_compare_type && dates.period_compare_type != 'date_picker'">
                                vergleichen mit
                                {{dates.period_compare_type.indexOf('year_') !== -1 ? 'Jahr ' + dates.period_compare_type.split('_').pop() : $t('intern_statistics.' + dates.period_compare_type)}}
                            </template>
                        </div>
                        <div
                            class="d-inline-block mr-2 font-12 pointer"
                            v-if="dates.date && Object.keys(dates.date).length > 0"
                            @click="emptyDateFilterWithCustomDates()"
                        >
                            <font-awesome-icon icon="times" style="font-size:14px; color: red;"/>
                            Zeitraum vom {{dates.date.start | date}} bis {{dates.date.end | date}}
                            <template v-if="dates.dateCompare && Object.keys(dates.dateCompare).length > 0">
                                vergleichen mit Zeitraum vom {{dates.dateCompare.start | date}} bis {{dates.dateCompare.end | date}}
                            </template>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="btn-group float-right">
                            <button type="button" @click="$emit('display_mode', !display_chart)" class="btn" :class="{'btn-dark': display_chart, 'btn-success': !display_chart}">
                                <font-awesome-icon icon="table"/>
                            </button>
                            <button type="button" @click="$emit('display_mode', !display_chart)" class="btn" :class="{'btn-dark': !display_chart, 'btn-success': display_chart}">
                                <font-awesome-icon icon="chart-line"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal ref="period_modal" :title="'Zeitraum wählen'" :hide-footer="true" :no-close-on-backdrop="true">

                <period-filter-component v-model="dates" ></period-filter-component>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import PeriodFilterComponent from './PeriodFilter';
    import EventBus              from '../../EventBus';

    export default {
        data() {
            return {
                selected_objects:      [],
                object_list:           this.$store.state.tinyObjects.all,
                category_list:         [],
                selected_categories:   [],
                improvement_list:      [],
                selected_improvements: [],
                has_filter:            false,
                grey_zo_cat:           false,
                grey_objects:          false,
                dates: {
                    date: {},
                    dateCompare: {},
                    period_type: '',
                    period_compare_type: '',
                },
            }
        },
        props: {
            filters: {
                type: Object,
                required: true,
                default() {
                    return {};
                }
            },
            display_chart: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        model: {
            prop: 'filters',
            event: 'search'
        },
        watch: {
            dates(val) {
                this.dates = val;
                this.$refs.period_modal.hide();
                this.setFilters();
                this.has_filter = this.hasFilter();
            },
            selected_objects(val){
                if(val.length > 0){
                    this.selected_categories   = [];
                    this.selected_improvements = [];
                    this.grey_zo_cat  = true;
                    this.grey_objects = false;
                } else {
                    this.grey_zo_cat = false;
                }
                this.setFilters();
                this.has_filter = this.hasFilter();
            },
            selected_categories(val){
                if(val.length > 0){
                    this.selected_objects = [];
                    this.grey_zo_cat  = false;
                    this.grey_objects = true;
                } else {
                    this.grey_objects = false;
                }
                this.setFilters();
                this.has_filter = this.hasFilter();
            },
            selected_improvements(val){
                if(val.length > 0){
                    this.selected_objects = [];
                    this.grey_zo_cat  = false;
                    this.grey_objects = true;
                } else {
                    this.grey_objects = false;
                }
                this.setFilters();
                this.has_filter = this.hasFilter();
            }
        },
        components: {
            PeriodFilterComponent
        },
        methods: {
            clearFilters() {

                this.selected_objects       = [];
                this.selected_categories    = [];
                this.selected_improvements  = [];
                this.dates.date             = {};
                this.dates.dateCompare      = {};
                this.dates.period_type         = '';
                this.dates.period_compare_type = '';
                setTimeout(() => {
                  this.has_filter = false;
                },100);
                this.$emit('search', {});
            },
            emptyDateFilterWithCustomDates(){
              this.dates = {date: {}, dateCompare: {}};
              setTimeout(() =>{
                this.has_filter = this.hasFilter(true);
              },100);
              this.setFilters();
            },
            emptyDateFilter(){
              this.dates.period_type = '';
              this.dates.period_compare_type = '';
              setTimeout(() =>{
              this.has_filter = this.hasFilter(true);
              },100);
              this.setFilters();
            },
            hasFilter(isIncludePeriodType = false) {
                if (
                        this.selected_objects.length > 0
                        ||
                        this.selected_categories.length > 0
                        ||
                        this.selected_improvements.length > 0
                        ||
                        (this.dates.date && Object.keys(this.dates.date).length > 0)
                        ||
                        (this.dates.period_type != 'date_picker' && !isIncludePeriodType)
                ) {
                    return true;
                } else {
                    return false;
                }

            },
            removeItemFromFilter(id, whichArray) {
                this[whichArray] = this[whichArray].filter(item => item.id != id);
                this.has_filter = this.hasFilter(true);
            },
            formatDate(date){
                return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            },
            setFilters() {
                let filters = {};
                if(this.selected_objects.length > 0){
                    filters.objects = this.selected_objects.map(object => object.id);
                }
                if(this.selected_improvements.length > 0){
                    EventBus.$emit('ADD_COLUMN', 'improvements');
                    filters.improvements = this.selected_improvements.map(improvement => improvement.key);
                }
                if(this.selected_categories.length > 0){
                    EventBus.$emit('ADD_COLUMN', 'category');
                    filters.categories = this.selected_categories.map(category => category.id);
                }
                if(this.dates.period_type) {
                    filters.period = {
                        type: this.dates.period_type,
                        type_compare: this.dates.period_compare_type,
                    }
                }
                if(this.dates.date && Object.keys(this.dates.date).length > 0){
                    filters.date = {
                        from: this.formatDate(this.dates.date.start),
                        to:   this.formatDate(this.dates.date.end)
                    }
                }
                if(this.dates.dateCompare && Object.keys(this.dates.dateCompare).length > 0){
                    filters.dateCompare = {
                        from: this.formatDate(this.dates.dateCompare.start),
                        to:   this.formatDate(this.dates.dateCompare.end)
                    }
                }

                if(Object.keys(filters).length > 0 || Object.keys(this.filters).length > 0){
                    this.$emit('search', filters);
                }
            },
        },
        created() {
            this.object_list       = this.$store.state.tinyObjects.all;

            if(!this.object_list){
                this.$store.dispatch('TINY_OBJECTS');
                this.$store.watch(() => {
                    return this.$store.getters.tinyObjects.all;
                }, all => {
                    this.object_list = all;
                });
            }

            this.$store.state.loading = true;

            this.$http.get('/categoryApi/getAllCategoriesOfUser').then(response => {
                this.category_list = JSON.parse(response.data);
            }).catch(error => {
                console.log(error);
            }).then(() => {
                this.$http.get('/buchungApi/getExtensions').then( response => {
                    let extensions            = JSON.parse(response.data);
                    this.improvement_list     = extensions;
                }).catch( error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                });
            })
        }
    }
</script>

<style scoped>
.abs {
    position: absolute;
    top: 12px;
    left: 22px;
    color: #28a745;
}
</style>
